import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { MyPageHead } from "../common/index";

import authCheck from "components/common/useAuthCheck";

import { EachContent } from "../common/style";

import arrow from "../../../../assets/icons/arrow-right.svg";

const Mypage = () => {
  const navigate = useNavigate();

  const [auth, setAuth] = useState(false);

  React.useEffect(() => {
    const enter = authCheck("NORMAL");
    if (enter === true) {
      setAuth(true);
    } else {
      navigate("/login");
    }
  }, [auth]);

  const image = localStorage.getItem("profileImage");
  const nickname = localStorage.getItem("nickname");
  const annual = localStorage.getItem("annual");
  const city = localStorage.getItem("city");
  const region = localStorage.getItem("region");

  return (
    <WholeWrapper>
      <MyPageHead title="내 정보" />
      <AgreeContainer>
        <ProfileInfoContainer>
          <ProfileWrapper>
            <Imgbox>
              <ProfileImg src={image} />
            </Imgbox>
            <ProfileContainer>
              <Nickname>{nickname}</Nickname>
              {region !== "null" && city !== "null" && annual !== "null" && (
                <Desc>
                  {annual}년차 / {city} {region}
                </Desc>
              )}
            </ProfileContainer>
          </ProfileWrapper>
          <EditInfoBtn onClick={() => navigate("/mypage/edit")}>
            <div>프로필 수정</div>
          </EditInfoBtn>
        </ProfileInfoContainer>
        <EachContent
          onClick={() => navigate("/signup", { state: { isRegDone: true } })}
        >
          <div>사업자 인증하기</div>
          <Arrow src={arrow} />
        </EachContent>
        <EachContent onClick={() => navigate("/mypage/feed")}>
          <div>내가 쓴 글</div>
          <Arrow src={arrow} />
        </EachContent>
        <EachContent onClick={() => navigate("/community-guide")}>
          <div>커뮤니티 가이드라인</div>
          <Arrow src={arrow} />
        </EachContent>
        <EachContent onClick={() => navigate("/market/LikeList")}>
          <div>도매상 찜 목록</div>
          <Arrow src={arrow} />
        </EachContent>
        <EachContent
          onClick={() =>
            window.open(
              "https://flowayofficial.slack.com/archives/C03MGN9AGLW/p1658311897972629"
            )
          }
        >
          <div>문의하기</div>
          <Arrow src={arrow} />
        </EachContent>
        <EachContent onClick={() => navigate(`/mypage/setting`)}>
          <div>설정</div>
          <Arrow src={arrow} />
        </EachContent>
      </AgreeContainer>
    </WholeWrapper>
  );
};

const WholeWrapper = styled.div`
  width: 100%;
  height: calc(100% - 25px);
  margin: auto;
  position: relative;
`;

const AgreeContainer = styled.div`
  width: 90%;
  margin: 0px auto;
  padding-top: 10px;
`;

const ProfileInfoContainer = styled.div`
  height: 168px;
`;

const Imgbox = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 70%;
  overflow: hidden;
`;

const ProfileImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ProfileWrapper = styled.div`
  display: flex;
  margin: 30px 0px;
`;

const ProfileContainer = styled.div`
  margin: auto 20px;
`;

const Nickname = styled.div`
  font-weight: 500;
`;

const Desc = styled.div`
  font-size: 13px;
`;

const EditInfoBtn = styled.div`
  height: 40px;
  width: 100%;
  border-radius: 20px;
  border: 1px solid #dfe2e6;
  color: #4a5056;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
`;

const Arrow = styled.img`
  width: 1.5rem;
`;

export default Mypage;
